import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContractBriefReportComponent } from '../pages/contract-brief-report/contract-brief-report.component';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';
import { AdvertisementDetailsComponent } from '../pages/advertisement-details/advertisement-details.component';

@Component({
  selector: 'app-commmodal',
  templateUrl: './commmodal.component.html',
  styleUrls: ['./commmodal.component.scss']
})
export class CommmodalComponent implements OnInit {
  myForm: FormGroup;
  data1: any;

  CommissionPayment = new FormGroup({
    bank_no: new FormControl(),
    bank_Acname: new FormControl(),
    bank_date: new FormControl(),
    end: new FormControl(),
    bank_bname: new FormControl(),
    bank_IFSC: new FormControl(),
    bank_Branch: new FormControl(),
    bank_Cheque: new FormControl(),
    commission_percentage: new FormControl(),
    tds_percentage: new FormControl(),
    commission_no: new FormControl(),
    voucher_no: new FormControl(),
    cheque_date: new FormControl(),
    voucher_date: new FormControl(),
    round_off_amount: new FormControl(),
    round_off_remark: new FormControl()


  });

  setPaymentdata: any;
  getmodaldata: any;
  gettotal: any;
  commission: any;
  tds: any;
  NetPay: any;
  tdspercentage: any;
  balamount: any;
  commissionAmount: any;
  commissionPercentage: any;
  totalSelectedAmount: any;
  seamt: any;
  tdsamount: any;
  rcpt_no: any;
  rcvamt: any;
  round_off_amount: any;
  rcpt_date: any;
  round_off_remark :any;
  crdtvamt:any;
  commissionAmount1:any;


  constructor(
    private dialogRef: MatDialogRef<AdvertisementDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    debugger
    this.getmodaldata = this.data['ModalList'];
    this.commissionAmount1 = Number(this.data.commissionAmount) || 0;
    this.tdsamount = this.data['tdsAmt'];
    this.rcvamt = this.data['rcv_amt'];
    this.tdspercentage = this.data['tdspercentage'];
    this.balamount = this.data['balamount'];
    this.commissionAmount = this.data['seamt'];
    this.commissionPercentage = this.data['commissionPercentage'];
    this.rcpt_no = this.data['rcpt_no'];
    this.rcpt_date = this.data['rcpt_date'];
    this.crdtvamt = this.data['crdtvamt'];




    // Set form values from data
    this.CommissionPayment.patchValue({
      commission_no: this.rcpt_no,
      commission_percentage: this.commissionPercentage,
      tds_percentage: this.tdspercentage,
      voucher_no: this.data['voucher_no'] || '',
      bank_Cheque: this.data['cheque_no'] || '',
      cheque_date: this.data['chequeDate'] || '',
      voucher_date: this.data['voucher_date'] || this.data['voucherDate'] || '',
      bank_date: this.data['chequeDate'] || '' // You might want to use chequeDate for bank_date too
    });

    this.gettotal = 0;
  }

  // Calculate total net amount
  totalNetAmount(): number {
    if (!this.getmodaldata || !Array.isArray(this.getmodaldata)) {
      return 0;
    }
    return this.getmodaldata.reduce((sum, data) => {
      const netAmount = parseFloat(data.net_amount) || 0;
      return sum + netAmount;
    }, 0);
  }

  // Calculate total received amount
  totalRcvAmount(): number {
    if (!this.getmodaldata || !Array.isArray(this.getmodaldata)) {
      return 0;
    }
    return this.getmodaldata.reduce((sum, data) => {
      const rcvAmount = parseFloat(data.rcv_amt) || 0;
      return sum + rcvAmount;
    }, 0);
  }

  // Calculate total commission amount
  totalCommissionAmount(): number {
    if (!this.getmodaldata || !Array.isArray(this.getmodaldata)) {
      return 0;
    }
    return this.getmodaldata.reduce((sum, data) => {
      const commAmount = parseFloat(data.commissionAmount) || 0;
      return sum + commAmount;
    }, 0);
  }

  // Calculate total commission after TDS deduction
  totalCommissionAfterTDS(): number {
    // const totalCommission = this.totalCommissionAmount();
   const balance_amount = this.data['balamount'];
    const tdsAmount = parseFloat(this.tdsamount) || 0;
    return balance_amount - tdsAmount;
  }

  // Get formatted total commission amount (from data passed)
  getFormattedCommissionAmount(): string {
    return (parseFloat(this.balamount) || 0).toFixed(2);
  }

  // Get formatted TDS amount
  getFormattedTDSAmount(): string {
    return (parseFloat(this.tdsamount) || 0).toFixed(2);
  }




// getNetPayableAmount(): string {
//   const crdtvamt = parseFloat(this.data?.crdtvamt) || 0;
//   const tds = parseFloat(this.tdsamount) || 0;
//   const roundOff = parseFloat(this.CommissionPayment.get('round_off_amount')?.value) || 0;

//   return (crdtvamt - tds + roundOff).toFixed(2);
// }


// getNetPayableAmount(): string {
//   const commission = Number(this.commissionAmount) || 0;
//   const crdtvamt = Number(this.crdtvamt) || 0;
//   const tds = Number(this.tdsamount) || 0;
//   const roundOff = Number(this.CommissionPayment.get('round_off_amount')?.value) || 0;

//   // If commission amount is present, use it; otherwise use crdtvamt
//   const baseAmount = commission > 0 ? commission : crdtvamt;

//   return (baseAmount - tds + roundOff).toFixed(2);
// }10/01

getNetPayableAmount(): string {
  const totalCommission = Number(this.balamount) || 0; // Total commission
  const paidCommission = Number(this.crdtvamt) || 0; // Paid commission (if any)
  const tds = Number(this.tdsamount) || 0;
  const roundOff = Number(this.CommissionPayment.get('round_off_amount')?.value) || 0;

  // If paid commission exists, use it; otherwise use total commission
  const baseAmount = paidCommission > 0 ? paidCommission : totalCommission;

  return (baseAmount + roundOff).toFixed(2);
}



  // savecomdetails() {
  //   debugger
  //   console.log("data saved");

  //   const tdsPercent = parseFloat(this.data['tdspercentage']) || 0;
  //   const commissionPercent = parseFloat(this.data['commissionPercentage']) || 0;
  //   const commissionNo = this.data['rcpt_no'];
  //   const commissiondate = this.data['rcpt_date'];

  //   debugger;

  //   const req: any = {
  //     data: this.getmodaldata.map((data1: any) => {
  //       const baseAmt = parseFloat(data1.net_amount) || 0;
  //       const commissionAmt = Math.round(baseAmt * (commissionPercent / 100));
  //       const tdsAmt = Math.round(this.data['seamt'] * (tdsPercent / 100));
  //       const netCommissionAmt = Math.round(
  //         (baseAmt * (commissionPercent / 100)) - tdsAmt
  //       );


  //       return {
  //         advt_name: data1.advt_name,
  //         invoice_no: data1.advt_invoice_no,
  //         advt_no: data1.advt_id,
  //         com_paid_date: this.CommissionPayment.value.voucher_date || commissiondate,
  //         creation_date: new Date().toISOString().split('T')[0],
  //         com_amt: netCommissionAmt.toFixed(2),
  //         cheque_no: this.CommissionPayment.value.bank_Cheque,
  //         cheque_date: this.CommissionPayment.value.cheque_date,
  //         rep_name: data1.rep_name,
  //         bank_name: this.CommissionPayment.value.bank_bname,
  //         ifsc_code: this.CommissionPayment.value.bank_IFSC,
  //         account_no: this.CommissionPayment.value.bank_no,
  //         branch: this.CommissionPayment.value.bank_Branch,
  //         acc_name: this.CommissionPayment.value.bank_Acname,
  //         comm_percentage: commissionPercent,
  //         tds_percentage: tdsPercent,
  //         tds_amount: tdsAmt.toFixed(2),
  //         commision_no: commissionNo,
  //         voucher_no: this.CommissionPayment.value.voucher_no,
  //         voucher_date: this.CommissionPayment.value.voucher_date,
  //         round_off_amount: this.CommissionPayment.value.round_off_amount,
  //         round_off_remark: this.CommissionPayment.value.round_off_remark


  //       };
  //     })
  //   };

  //   console.log("new modal req", req);

  //   this.service.setPaymentcomm(req).subscribe(
  //     (data: any) => {
  //       console.log("Payment comm data", data);
  //       this.setPaymentdata = data;
  //       this.dialogRef.close({ success: true });
  //     },
  //     (error) => {
  //       console.error("Error saving commission", error);
  //     }
  //   );
  // }




// savecomdetails() {
//   debugger
//   console.log("data saved");

//   const tdsPercent = parseFloat(this.data['tdspercentage']) || 0;
//   const commissionPercent = parseFloat(this.data['commissionPercentage']) || 0;
//   const commissionNo = this.data['rcpt_no'];
//   const commissiondate = this.data['rcpt_date'];
  
//   // Get round off amount once (will be applied to total or split among entries)
//   const roundOffAmt = Number(this.CommissionPayment.value.round_off_amount) || 0;
  
//   // Calculate round off per entry if multiple entries
//   const roundOffPerEntry = this.getmodaldata.length > 0 ? roundOffAmt / this.getmodaldata.length : 0;

//   const formattedDate = this.convertToISO(commissiondate);

//   debugger;

//   const req: any = {
//     data: this.getmodaldata.map((data1: any) => {
      
//       // ✓ Get individual commission amount for THIS entry
//       const individualCommissionAmt = Number(data1.crdtvamt) || Number(data1.commissionAmount) || 0;
      
//       // ✓ Calculate TDS for THIS entry's commission
//       const individualTdsAmt = Math.round(individualCommissionAmt * (tdsPercent / 100));
      
//       // ✓ Calculate net commission for THIS entry after TDS
//       const netCommissionAmt = individualCommissionAmt - individualTdsAmt;
      
//       // ✓ Apply round off to THIS entry
//       const finalNetPayableAmt = netCommissionAmt + roundOffPerEntry;

//       return {
//         // ========== EXISTING TABLE FIELDS ==========
//         advt_no: data1.advt_id || null,
//         invoice_no: data1.advt_invoice_no,
//         crdtvamt: data1.crdtvamt || 0,
//         commision_no: commissionNo,
//         com_paid_date: this.CommissionPayment.value.voucher_date || commissiondate,
//         creation_date: new Date().toISOString().split('T')[0],
//         com_amt: finalNetPayableAmt.toFixed(2),  // ✓ Individual net payable for this entry
//         cheque_no: this.CommissionPayment.value.bank_Cheque || this.data['cheque_no'],
//         ifsc_code: this.CommissionPayment.value.bank_IFSC,
//         rep_name: data1.rep_name || this.data['repname'],
//         bank_name: this.CommissionPayment.value.bank_bname,
//         account_no: this.CommissionPayment.value.bank_no,
//         branch: this.CommissionPayment.value.bank_Branch,
//         acc_name: this.CommissionPayment.value.bank_Acname,
//         advt_name: data1.advt_name || this.data['advtname'],
//         booking_no: data1.booking_no || null,
//         is_cancel: 'N',
//         comm_percentage: commissionPercent,
//         tds_percentage: tdsPercent,
//         tds_amount: individualTdsAmt.toFixed(2),  // ✓ Individual TDS for this entry
//         round_off_amount: roundOffPerEntry.toFixed(2),  // ✓ Proportional round off
//         voucher_no: this.CommissionPayment.value.voucher_no,
//         voucher_date: this.CommissionPayment.value.voucher_date,
//         remark: this.CommissionPayment.value.round_off_remark || '',
        
//         // ========== NEW FIELDS ==========
//         invoice_date: data1.advt_invoice_date || null,
//         issue_name: data1.DS_ISSUENAME || null,
//         issue_date: data1.DS_ISSUEDATE || null,
//         net_amount: data1.net_amount || 0,
//         received_amount: data1.rcv_amt || 0,
//         pending_amount: data1.pending_amt || 0,
//         is_manual_entry: data1.isManualEntry || false,
        
//         // ========== ADDITIONAL COMMISSION FIELDS ==========
//         gross_commission_amt: individualCommissionAmt.toFixed(2),  // ✓ Individual gross commission
//         net_commission_amt: netCommissionAmt.toFixed(2)  // ✓ Individual net before round off
//       };
//     })
//   };

//   console.log("Complete request with all individual commission amounts:", req);

//   this.service.setPaymentcomm(req).subscribe(
//     (data: any) => {
//       console.log("Payment commission data saved successfully", data);
//       this.setPaymentdata = data;
//       this.dialogRef.close({ success: true, savedData: data });
//       alert('Commission payment saved successfully!');
//     },
//     (error) => {
//       console.error("Error saving commission", error);
//       alert('Error saving commission details. Please try again.');
//     }
//   );
// }


// savecomdetails() {
//   debugger
//   console.log("data saved");

//   const tdsPercent = parseFloat(this.data['tdspercentage']) || 0;
//   const commissionPercent = parseFloat(this.data['commissionPercentage']) || 0;
//   const commissionNo = this.data['rcpt_no'];
//   const commissiondate = this.data['rcpt_date'];
  
//   // Get round off amount
//   const roundOffAmt = Number(this.CommissionPayment.value.round_off_amount) || 0;
  
//   // ========== CALCULATE TOTALS ==========
//   // Calculate total commission from all entries
//   const totalCommission = this.getmodaldata.reduce((sum, data1) => {
//     const commAmt = Number(data1.crdtvamt) || Number(data1.commissionAmount) || 0;
//     return sum + commAmt;
//   }, 0);
  
//   // Calculate total TDS on total commission
//   const totalTdsAmt = Math.round(totalCommission * (tdsPercent / 100));
  
//   // Calculate total paid commission (after TDS + round off)
//   const totalPaidCommission = totalCommission - totalTdsAmt + roundOffAmt;
  
//   // Calculate balance commission (if any previous payments exist)
//   const previouslyPaid = Number(this.data['previouslyPaidAmount']) || 0;
//   const balanceCommission = totalCommission - previouslyPaid - totalPaidCommission;

//   const formattedDate = this.convertToISO(commissiondate);

//   debugger;

//   const req: any = {
//     data: this.getmodaldata.map((data1: any) => {
      
//       // ✓ Get individual commission amount for THIS entry
//       const individualCommissionAmt = Number(data1.crdtvamt) || Number(data1.commissionAmount) || 0;
      
//       // ✓ Calculate TDS for THIS entry's commission
//       const individualTdsAmt = Math.round(individualCommissionAmt * (tdsPercent / 100));
      
//       // ✓ Calculate net commission for THIS entry after TDS
//       const netCommissionAmt = individualCommissionAmt - individualTdsAmt;
      
//       // ✓ Calculate proportional round off for this entry
//       const entryRoundOff = totalCommission > 0 ? (individualCommissionAmt / totalCommission) * roundOffAmt : 0;
      
//       // ✓ Final net payable for this entry
//       const finalNetPayableAmt = netCommissionAmt + entryRoundOff;

//       return {
//         // ========== EXISTING TABLE FIELDS ==========
//         advt_no: data1.advt_id || null,
//         invoice_no: data1.advt_invoice_no,
//         crdtvamt: data1.crdtvamt || 0,
//         commision_no: commissionNo,
//         com_paid_date: this.CommissionPayment.value.voucher_date || commissiondate,
//         creation_date: new Date().toISOString().split('T')[0],
//         com_amt: finalNetPayableAmt.toFixed(2),  // ✓ Individual net payable for this entry
//         cheque_no: this.CommissionPayment.value.bank_Cheque || this.data['cheque_no'],
//         ifsc_code: this.CommissionPayment.value.bank_IFSC,
//         rep_name: data1.rep_name || this.data['repname'],
//         bank_name: this.CommissionPayment.value.bank_bname,
//         account_no: this.CommissionPayment.value.bank_no,
//         branch: this.CommissionPayment.value.bank_Branch,
//         acc_name: this.CommissionPayment.value.bank_Acname,
//         advt_name: data1.advt_name || this.data['advtname'],
//         booking_no: data1.booking_no || null,
//         is_cancel: 'N',
//         comm_percentage: commissionPercent,
//         tds_percentage: tdsPercent,
//         tds_amount: individualTdsAmt.toFixed(2),  // ✓ Individual TDS for this entry
//         round_off_amount: entryRoundOff.toFixed(2),  // ✓ Proportional round off
//         voucher_no: this.CommissionPayment.value.voucher_no,
//         voucher_date: this.CommissionPayment.value.voucher_date,
//         remark: this.CommissionPayment.value.round_off_remark || '',
        
//         // ========== NEW FIELDS ==========
//         invoice_date: data1.advt_invoice_date || null,
//         issue_name: data1.DS_ISSUENAME || null,
//         issue_date: data1.DS_ISSUEDATE || null,
//         net_amount: data1.net_amount || 0,
//         received_amount: data1.rcv_amt || 0,
//         pending_amount: data1.pending_amt || 0,
//         is_manual_entry: data1.isManualEntry || false,
        
//         // ========== COMMISSION TRACKING FIELDS ==========
//         gross_commission_amt: individualCommissionAmt.toFixed(2),  // ✓ Individual gross commission
//         net_commission_amt: netCommissionAmt.toFixed(2),  // ✓ Individual net before round off
        
//         // ========== TOTAL TRACKING FIELDS (SAME FOR ALL ENTRIES) ==========
//         total_commission: totalCommission.toFixed(2),  // ✓ Total commission across all entries
//         paid_commission: totalPaidCommission.toFixed(2),  // ✓ Amount being paid now (after TDS + round off)
//         balance_commission: balanceCommission.toFixed(2),  // ✓ Remaining balance
//         total_tds: totalTdsAmt.toFixed(2)  // ✓ Total TDS deducted
//       };
//     })
//   };

//   console.log("Complete request with total, paid, and balance commission:", req);

//   this.service.setPaymentcomm(req).subscribe(
//     (data: any) => {
//       console.log("Payment commission data saved successfully", data);
//       this.setPaymentdata = data;
//       this.dialogRef.close({ success: true, savedData: data });
//       alert('Commission payment saved successfully!');
//     },
//     (error) => {
//       console.error("Error saving commission", error);
//       alert('Error saving commission details. Please try again.');
//     }
//   );
// } 09/01



// savecomdetails() {
//   debugger
//   console.log("data saved");

//   const tdsPercent = parseFloat(this.data['tdspercentage']) || 0;
//   const commissionPercent = parseFloat(this.data['commissionPercentage']) || 0;
//   const commissionNo = this.data['rcpt_no'];
//   const commissiondate = this.data['rcpt_date'];
  
//   // Get round off amount
//   const roundOffAmt = Number(this.CommissionPayment.value.round_off_amount) || 0;
  
//   // ========== CALCULATE TOTALS ==========
//   // Total Commission from all entries
//   const totalCommission = this.getmodaldata.reduce((sum, data1) => {
//     const commAmt = Number(data1.commissionAmount) || Number(data1.crdtvamt) || 0;
//     return sum + commAmt;
//   }, 0);
  
//   // Total TDS
//   const totalTdsAmt = parseFloat(this.tdsamount) || 0;
  
//   // Check if paid commission exists (crdtvamt from data)
//   const paidCommissionFromData = Number(this.data['crdtvamt']) || 0;
  
//   // ✓ If paid commission exists, use it; otherwise use total commission
//   const paidCommission = paidCommissionFromData > 0 ? paidCommissionFromData : totalCommission;
  
//   // Net Payable = Paid Commission - TDS + Round Off
//   const netPayableAmount = paidCommission - totalTdsAmt + roundOffAmt;
  
//   // Balance Commission
//   const balanceCommission = totalCommission - paidCommission;

//   const formattedDate = this.convertToISO(commissiondate);

//   debugger;

//   const req: any = {
//     data: this.getmodaldata.map((data1: any) => {
      
//       // Individual commission for this entry
//       const individualCommissionAmt = Number(data1.commissionAmount) || Number(data1.crdtvamt) || 0;
      
//       // ✓ Calculate proportion based on paid commission (or total if no paid commission)
//       const proportionOfPaid = totalCommission > 0 ? (individualCommissionAmt / totalCommission) * paidCommission : 0;
      
//       // Calculate proportional TDS for this entry
//       const individualTdsAmt = totalCommission > 0 ? (individualCommissionAmt / totalCommission) * totalTdsAmt : 0;
      
//       // Calculate proportional round off for this entry
//       const entryRoundOff = totalCommission > 0 ? (individualCommissionAmt / totalCommission) * roundOffAmt : 0;
      
//       // ✓ Net payable (com_amt) = Proportional Paid - Proportional TDS + Proportional Round Off
//       const finalNetPayableAmt = proportionOfPaid - individualTdsAmt + entryRoundOff;

//       return {
//         // ========== EXISTING TABLE FIELDS ==========
//         advt_no: data1.advt_id || null,
//         invoice_no: data1.advt_invoice_no,
//         crdtvamt: proportionOfPaid.toFixed(2), // Proportional paid commission
//         commision_no: commissionNo,
//         com_paid_date: this.CommissionPayment.value.voucher_date || commissiondate,
//         creation_date: new Date().toISOString().split('T')[0],
//         com_amt: finalNetPayableAmt.toFixed(2),  // ✓ This is the key field - net payable amount
//         cheque_no: this.CommissionPayment.value.bank_Cheque || this.data['cheque_no'],
//         cheque_date: this.CommissionPayment.value.cheque_date || this.data['cheque_date'],
//         ifsc_code: this.CommissionPayment.value.bank_IFSC,
//         rep_name: data1.rep_name || this.data['repname'],
//         bank_name: this.CommissionPayment.value.bank_bname,
//         account_no: this.CommissionPayment.value.bank_no,
//         branch: this.CommissionPayment.value.bank_Branch,
//         acc_name: this.CommissionPayment.value.bank_Acname,
//         advt_name: data1.advt_name || this.data['advtname'],
//         booking_no: data1.booking_no || null,
//         is_cancel: 'N',
//         comm_percentage: commissionPercent,
//         tds_percentage: tdsPercent,
//         tds_amount: individualTdsAmt.toFixed(2),
//         round_off_amount: entryRoundOff.toFixed(2),
//         voucher_no: this.CommissionPayment.value.voucher_no,
//         voucher_date: this.CommissionPayment.value.voucher_date,
//         remark: this.CommissionPayment.value.round_off_remark || '',
        
//         // ========== NEW FIELDS ==========
//         invoice_date: data1.advt_invoice_date || null,
//         issue_name: data1.DS_ISSUENAME || null,
//         issue_date: data1.DS_ISSUEDATE || null,
//         net_amount: data1.net_amount || 0,
//         received_amount: data1.rcv_amt || 0,
//         pending_amount: data1.pending_amt || 0,
//         is_manual_entry: data1.isManualEntry || false,
        
//         // ========== COMMISSION TRACKING FIELDS ==========
//         gross_commission_amt: individualCommissionAmt.toFixed(2),
//         net_commission_amt: finalNetPayableAmt.toFixed(2),
        
//         // ========== TOTAL TRACKING FIELDS ==========
//         total_commission: totalCommission.toFixed(2),
//         paid_commission: paidCommission.toFixed(2),  // ✓ Either crdtvamt or total commission
//         balance_commission: balanceCommission.toFixed(2),
//         total_tds: totalTdsAmt.toFixed(2),
//         net_payable_amount: netPayableAmount.toFixed(2)
//       };
//     })
//   };

//   console.log("Complete request - com_amt contains net payable:", req);
//   console.log(`Using ${paidCommissionFromData > 0 ? 'Paid Commission' : 'Total Commission'} as base`);

//   this.service.setPaymentcomm(req).subscribe(
//     (data: any) => {
//       console.log("Payment commission data saved successfully", data);
//       this.setPaymentdata = data;
//       this.dialogRef.close({ success: true, savedData: data });
//       alert('Commission payment saved successfully!');
//     },
//     (error) => {
//       console.error("Error saving commission", error);
//       alert('Error saving commission details. Please try again.');
//     }
//   );
// }


savecomdetails() {
  debugger
  console.log("data saved");

  const tdsPercent = parseFloat(this.data['tdspercentage']) || 0;
  const commissionPercent = parseFloat(this.data['commissionPercentage']) || 0;
  const commissionNo = this.data['rcpt_no'];
  const commissiondate = this.data['rcpt_date'];
  
  // Get round off amount
  const roundOffAmt = Number(this.CommissionPayment.value.round_off_amount) || 0;
  
  // ========== CRITICAL FIX: Calculate totals from the modal data ==========
  // Sum of all commission amounts from the table
  const sumOfCommissionAmounts = this.getmodaldata.reduce((sum, data1) => {
    return sum + (Number(data1.commissionAmount) || 0);
  }, 0);
  
  console.log("Sum of commission amounts from table:", sumOfCommissionAmounts);
  
  // Total Commission (from balamount - this is the ACTUAL total)
  const totalCommission = Number(this.balamount) || Number(this.data['balamount']) || 0;
  
  // Total TDS
  const totalTdsAmt = parseFloat(this.tdsamount) || 0;
  
  // Paid commission from data
  const paidCommissionFromData = Number(this.data['crdtvamt']) || 0;
  
  // ✓ If paid commission exists, use it; otherwise use total commission
  const paidCommission = paidCommissionFromData > 0 ? paidCommissionFromData : totalCommission;
  
  // Net Payable = Paid Commission - TDS + Round Off
  const netPayableAmount = paidCommission - totalTdsAmt + roundOffAmt;
  
  // Balance Commission = Total - Paid
  const balanceCommission = totalCommission - paidCommission;

  const formattedDate = this.convertToISO(commissiondate);

  debugger;
  
  console.log("=== CALCULATION VERIFICATION ===");
  console.log("Sum of table commission amounts:", sumOfCommissionAmounts);
  console.log("Total Commission (balamount):", totalCommission);
  console.log("Paid Commission (crdtvamt):", paidCommission);
  console.log("Balance Commission:", balanceCommission);
  console.log("TDS Amount:", totalTdsAmt);
  console.log("Round Off:", roundOffAmt);
  console.log("Net Payable:", netPayableAmount);
  console.log("================================");

  const req: any = {
    data: this.getmodaldata.map((data1: any) => {
      
      // Individual commission for this entry from the table
      const individualCommissionAmt = Number(data1.commissionAmount) || 0;
      
      // ✓ FIX: Calculate proportion using sumOfCommissionAmounts (not totalCommission)
      // This ensures the proportions add up correctly
      const proportionOfTotal = sumOfCommissionAmounts > 0 
        ? individualCommissionAmt / sumOfCommissionAmounts 
        : 0;
      
      // Now apply this proportion to the PAID commission
      const proportionOfPaid = proportionOfTotal * paidCommission;
      
      // Calculate proportional TDS for this entry's paid amount
      const individualTdsAmt = proportionOfTotal * totalTdsAmt;
      
      // Calculate proportional round off for this entry
      const entryRoundOff = proportionOfTotal * roundOffAmt;
      
      // ✓ com_amt = Net payable for this entry (Paid - TDS + Round Off)
      const finalNetPayableAmt = proportionOfPaid - individualTdsAmt + entryRoundOff;

      console.log(`Entry ${data1.advt_invoice_no}:`, {
        individualComm: individualCommissionAmt,
        proportion: proportionOfTotal,
        proportionalPaid: proportionOfPaid,
        proportionalTds: individualTdsAmt,
        proportionalRoundOff: entryRoundOff,
        finalNetPayable: finalNetPayableAmt
      });

      return {
        // ========== EXISTING TABLE FIELDS ==========
        advt_no: data1.advt_id || null,
        invoice_no: data1.advt_invoice_no,
        crdtvamt: proportionOfPaid.toFixed(2), // ✓ Should sum to 98000
        commision_no: commissionNo,
        com_paid_date: this.CommissionPayment.value.voucher_date || commissiondate,
        creation_date: new Date().toISOString().split('T')[0],
        com_amt: finalNetPayableAmt.toFixed(2),  // ✓ NET PAYABLE
        cheque_no: this.CommissionPayment.value.bank_Cheque || this.data['cheque_no'],
        cheque_date: this.CommissionPayment.value.cheque_date || this.data['cheque_date'],
        ifsc_code: this.CommissionPayment.value.bank_IFSC,
        rep_name: data1.rep_name || this.data['repname'],
        bank_name: this.CommissionPayment.value.bank_bname,
        account_no: this.CommissionPayment.value.bank_no,
        branch: this.CommissionPayment.value.bank_Branch,
        acc_name: this.CommissionPayment.value.bank_Acname,
        advt_name: data1.advt_name || this.data['advtname'],
        booking_no: data1.booking_no || null,
        is_cancel: 'N',
        comm_percentage: commissionPercent,
        tds_percentage: tdsPercent,
        tds_amount: individualTdsAmt.toFixed(2),
        round_off_amount: entryRoundOff.toFixed(2),
        voucher_no: this.CommissionPayment.value.voucher_no,
        voucher_date: this.CommissionPayment.value.voucher_date,
        remark: this.CommissionPayment.value.round_off_remark || '',
        
        // ========== NEW FIELDS ==========
        invoice_date: data1.advt_invoice_date || null,
        issue_name: data1.DS_ISSUENAME || null,
        issue_date: data1.DS_ISSUEDATE || null,
        net_amount: data1.net_amount || 0,
        received_amount: data1.rcv_amt || 0,
        pending_amount: data1.pending_amt || 0,
        is_manual_entry: data1.isManualEntry || false,
        
        // ========== COMMISSION TRACKING FIELDS ==========
        gross_commission_amt: individualCommissionAmt.toFixed(2),
        net_commission_amt: finalNetPayableAmt.toFixed(2),
        
        // ========== TOTAL TRACKING FIELDS ==========
        total_commission: totalCommission.toFixed(2),  // ✓ 151000
        paid_commission: paidCommission.toFixed(2),  // ✓ 98000
        balance_commission: balanceCommission.toFixed(2),  // ✓ 53000
        total_tds: totalTdsAmt.toFixed(2),
        net_payable_amount: netPayableAmount.toFixed(2)
      };
    })
  };

  // ✓ Verify the sum of crdtvamt equals paidCommission
  const sumOfCrdtvamt = req.data.reduce((sum, item) => sum + parseFloat(item.crdtvamt), 0);
  console.log("=== FINAL VERIFICATION ===");
  console.log("Sum of all crdtvamt values:", sumOfCrdtvamt.toFixed(2));
  console.log("Expected (Paid Commission):", paidCommission.toFixed(2));
  console.log("Difference:", Math.abs(sumOfCrdtvamt - paidCommission).toFixed(2));
  console.log("========================");

  console.log("Complete request payload:", req);

  this.service.setPaymentcomm(req).subscribe(
    (data: any) => {
      console.log("Payment commission data saved successfully", data);
      this.setPaymentdata = data;
      this.dialogRef.close({ success: true, savedData: data });
      alert('Commission payment saved successfully!');
    },
    (error) => {
      console.error("Error saving commission", error);
      alert('Error saving commission details. Please try again.');
    }
  );
}


  closeexp(): void {
    this.dialogRef.close();
  }

  exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section1');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section1" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

convertToISO(dateStr: string): string | null {
  if (!dateStr) return null;

  const parts = dateStr.split('-');
  if (parts.length !== 3) return null;

  const [day, month, year] = parts;
  return `${year}-${month}-${day}`;
}


// getBalanceCommission(): string {
//   const total = Number(this.getFormattedCommissionAmount()) || 0;
//   const paid = Number(this.data?.crdtvamt) || 0;

//   const balance = total - paid;

//   return balance.toFixed(2);
// }



getBalanceCommission(): string {
  const totalCommission = Number(this.balamount) || 0;
  const paidCommission = Number(this.crdtvamt) || 0;

  // If there's paid commission, calculate balance
  if (paidCommission > 0) {
    return (totalCommission - paidCommission).toFixed(2);
  }
  
  // If no paid commission, balance is 0 (full payment)
  return '0.00';
}


}